import React, { ReactElement, useCallback, useState } from 'react';

import {
  FormControl,
  FormHelperText,
  OutlinedInput,
  FormLabel,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { useField, useFormikContext } from 'formik';

import { useStyles } from './generic-password-field.styles';

interface Props {
  id: string;
  label: string;
  name: string;
  placeholder?: string;
  className?: any;
  hideError?: boolean;
}

export default function GenericPasswordField(props: Props): ReactElement {
  const classes = useStyles();
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = useCallback(() => setShowPassword(!showPassword), [showPassword]);

  const handleChange = useCallback(
    (event) => {
      setFieldValue(field.name, event.target.value);
    },
    [field.name, setFieldValue]
  );

  return (
    <FormControl fullWidth={true} error={meta.error && meta.touched ? true : false}>
      <FormLabel className={classes.label} htmlFor={props.id}>
        {props.label}
      </FormLabel>
      <OutlinedInput
        id={props.id}
        className={`${props.className} ${classes.input}`}
        name={props.name}
        placeholder={props.placeholder}
        type={showPassword ? 'text' : 'password'}
        value={field.value}
        onChange={handleChange}
        onBlur={field.onBlur}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton size='small' onClick={handleClickShowPassword}>
              {showPassword ? <Visibility data-testid='on' /> : <VisibilityOff data-testid='off' />}
            </IconButton>
          </InputAdornment>
        }
        error={(meta.error && meta.touched) as boolean}
      />
      {!props.hideError && meta.error && (
        <FormHelperText id={`${props.id}-helper-text`}>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
}
